<template>
    <tenancies-update
        :uuid="tenancy.uuid"
        @success="show_edit_modal = false; show_updated_modal = true"
    >
        <div
            slot-scope="{
                sid,
                is_loading: is_saving,
                error,
                update,
                forget
            }"
        >
            <error-modal
                v-if="error && $error.is(error, { exclude: [422] })"
                :error="error"
                @close="forget"
            />

            <modal-success
                v-else-if="show_updated_modal"
                :is-open="show_updated_modal"
                @close="closeAll(); $emit('success')"
            >
                <template slot="heading">Tenancy Updated!</template>

                <p>The rolling state for this tenancy has been updated.</p>

                <div
                    slot="footer"
                    slot-scope="{ close }"
                    class="flex flex-col md:flex-row-reverse"
                >
                    <button
                        type="button"
                        @click.prevent="close"
                        class="btn text-center"
                    >
                        Close
                    </button>
                </div>
            </modal-success>

            <modal-blue
                v-else-if="show_edit_modal"
                :is-open="show_edit_modal"
                @close="closeAll"
            >
                <base-form
                    slot-scope="{ close }"
                    @submit="update(form)"
                >
                    <div class="border-b px-4 pt-6 sm:px-6">
                        <h6 class="text-center font-semibold text-lg font-normal mb-3">
                            Toggle Rolling
                        </h6>

                        <div class="text-grey-darker mb-6">
                            <p class="mb-3">
                                A <strong>rolling</strong> tenancy will continue on a periodic month-to-month, basis beyond the term.
                            </p>

                            <p>
                                A <strong>non-rolling</strong> tenancy will automatically terminate once it reaches the end of the term.
                            </p>
                        </div>

                        <validator-alert :sid="sid" />

                        <grid-layout>
                            <grid-layout-item class="md:w-1/2">
                                <form-item
                                    :sid="sid"
                                    name="is_rolling"
                                >
                                    <label class="flex items-center cursor-pointer">
                                        <input-checkbox
                                            v-model="form.is_rolling"
                                            :sid="sid"
                                            name="is_rolling"
                                        />

                                        <div class="ml-3 mt-2px leading-none">Roll this tenancy</div>
                                    </label>
                                </form-item>
                            </grid-layout-item>
                        </grid-layout>
                    </div>

                    <footer class="flex flex-col md:flex-row-reverse bg-grey-bg rounded-b py-3 px-6">
                        <base-button
                            :is-loading="is_saving"
                            type="submit"
                            class="btn btn-blue w-full md:w-auto"
                        >
                            Update Tenancy
                        </base-button>

                        <button
                            type="button"
                            class="btn text-center md:mr-3"
                            @click.prevent="close"
                        >
                            Cancel
                        </button>
                    </footer>
                </base-form>
            </modal-blue>
        </div>
    </tenancies-update>
</template>

<script>
    import TenanciesUpdate from '../../../../../../components/tenancies-update'

    export default {
        components: {
            TenanciesUpdate
        },
        model: {
            prop: 'toggled',
            event: 'toggle'
        },
        props: {
            toggled: {
                type: Boolean,
                required: true
            },
            tenancy: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                show_edit_modal: this.toggled,
                show_updated_modal: false,
                form: {
                    is_rolling: this.tenancy.is_rolling
                }
            }
        },
        watch: {
            toggled () {
                this.show_edit_modal = this.toggled
            }
        },
        methods: {
            closeAll () {
                this.show_updated_modal = false
                this.show_edit_modal = false

                this.$emit('toggle', false)
            },
            onSuccess () {
                this.show_edit_modal = false
                this.show_updated_modal = true
            }
        }
    }
</script>
